import { useState, useEffect } from "react";
import { getExperiementalChatbotEnabled } from "../components/chatbot/utils";

/**
 * Custom hook to monitor chatbot state and determine if content should shrink
 * @returns Object containing isChatbotOpen, shouldShrinkContent, and experiementalChatbotEnabled flags
 */
export function useChatbotState() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  const experiementalChatbotEnabled = getExperiementalChatbotEnabled();
  const shouldShrinkContent = experiementalChatbotEnabled && isChatbotOpen;

  useEffect(() => {
    const checkChatbotState = () => {
      const isOpen = window.SmartMerchandiserChatbot?.isOpen?.() ?? false;
      setIsChatbotOpen(isOpen);
    };

    checkChatbotState();

    // Watch for changes in the chatbot container to detect open/close
    const chatbotContainer = document.getElementById("chatbot-container");

    const observer = new MutationObserver(() => {
      checkChatbotState();
    });

    if (chatbotContainer) {
      observer.observe(chatbotContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return {
    isChatbotOpen,
    shouldShrinkContent,
    experiementalChatbotEnabled,
  };
}
